interface JwtPayload {
    username: string;
    authenticated: boolean;
    exp: number;
}

class AuthProvider {
    // Secret key used to sign the JWT token
    // eslint-disable-next-line no-useless-constructor, @typescript-eslint/no-empty-function
    constructor() {}

    generateSessionId(): string {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const length = 20; // You can adjust the length of the session ID as needed
        let sessionId = '';

        for (let i = 0; i < length; i += 1) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            sessionId += characters[randomIndex];
        }

        return `anonymous_${sessionId}`;
    }

    async generateJwtToken(username?: string | null, authenticated?: boolean): Promise<Response> {
        let uname = '';
        let isAuthenticated = false;
        if (!username) {
            uname = this.generateSessionId();
            isAuthenticated = false;
        } else {
            isAuthenticated = authenticated ?? true;
        }

        const payload: JwtPayload = {
            username: uname,
            authenticated: isAuthenticated,
            exp: Math.floor(Date.now() / 1000) + (60 * 60 * 24), // Token expiration time (1 day)
        };

        const currentHost = `${window.location.protocol}//${window.location.host}`;
        const backendURL = window.backendURL ?? currentHost;

        const token = await fetch(`${backendURL}/api/JwtToken/GetJwtToken?username=${uname}`);
        sessionStorage.setItem('user', JSON.stringify({ access_token: await token.json(), ...payload }));
        return token;
    }

    getUser(): Promise<unknown> {
        return new Promise((resolve, reject) => {
            const user = sessionStorage.getItem('user');

            if (user) {
                resolve(JSON.parse(user));
            } else {
                this.generateJwtToken(null).then(() => {
                    const newUser = sessionStorage.getItem('user');
                    if (newUser) {
                        resolve(JSON.parse(newUser));
                    } else {
                        reject(new Error('Failed to retrieve user from session storage'));
                    }
                });
            }
        });
    }

    signinRedirect(args: { state: string }): void {
        this.generateJwtToken('authenticated_user');
        window.location.href = args.state;
    }

    signoutRedirect(): void {
        this.generateJwtToken(null);
        window.location.reload();
    }

    refreshAccessToken(): void {
        this.getUser().then(user => {
            const typedUser = user as JwtPayload;
            return this.generateJwtToken(typedUser.username, typedUser.authenticated);
        });
    }
}

export default AuthProvider;
